/**
 * A master's shared defaults: the amount every follower's drops take unless
 * a slot or the follower says otherwise. What a list failing mid-day does
 * sits with the list verdicts. (Interval, start and end stay on each container.)
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { DropDefaultsRows } from '../general/schedule/DropDefaultsRows';
import type { ContainerEditor } from '../state/useContainerEditor';

export const MasterDefaultsStep: FC<{ editor: ContainerEditor }> = ({ editor }) => (
  <div className="divide-y divide-border/50">
    <DropDefaultsRows editor={editor} />
  </div>
);
